import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { LoggerService } from '../../logger/logger';

@Injectable()
export class ClientSettingsService {
  settings: any = {};

  constructor(
    @Inject(DOCUMENT) private document: any,
    private logger: LoggerService,
  ) {
    const element = document.getElementById('client-settings');
    const innerHTML = element ? element.innerHTML : '';

    if (!element) {
      this.log('message=client-settings element not found', 100);
    }

    try {
      this.settings = JSON.parse(innerHTML);
    } catch (error) {
      this.log('message=innerHTML parse error;html=' + innerHTML, 101);
      this.settings = {};
    }
  }

  public getServiceAddress(service) {
    const services = this.settings.services || null;

    if (!services) {
      this.log('message=No services provided', 102);
      return '';
    }

    if (!services[service]) {
      this.log('message=Service address missing: ' + service, 103);
      return '';
    }

    return services[service];
  }

  public getDomainAddress(domain) {
    const domains = this.settings.domains || null;

    if (!domains) {
      this.log('message=No domains provided', 104);
      return '';
    }

    if (!domains[domain]) {
      this.log('message=Domain address missing: ' + domain, 105);
      return '';
    }

    return domains[domain];
  }

  private log(message, code) {
    const msg = [];

    msg.push('class=ClientSettingsService');
    msg.push(message);

    this.logger.error({ message: msg.join(';') }, code);
  }
} /* istanbul ignore next */
